<template>
  <div class="page-container">
    <div class="notification is-primary">
      You have successfully unsubscribed from our mailing list.
    </div>
  </div>
</template>

<script>
export default {
  name: 'Unsubscribed'
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 36px 0 45px;

  .notification {
    max-width: 1125px;
    margin: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Unsubscribed.vue